export enum Reasons {
  DAILY_MAINTENANCE = "daily_maintenance",
  REPLACE_PRODUCT = "replace_product",
  REMOVE_PRODUCT = "remove_product",
  SALES_STOP = "sales_stop",
}

export enum TaskListingTypes {
  Ongoing = "ongoing",
  NotOngoing = "not_ongoing",
  All = "all",
}

export enum TaskOwner {
  Mine = "mine",
  Team = "team",
  All = "all",
}

export enum MediaFormFieldTypes {
  STYLE_GROUP = "Style group",
  LIVING_SITUATION = "Living situation",
  LONG_TERM_PRIORITY = "Long term priority",
  PRICING = "Pricing",
  AREA_HFB = "Area / Hfb",
}

export const homeFurnishingSolutionsRequiredFields: string[] = [
  "livingSituation",
  "hfLtp",
  "styleGroup",
  "pricing",
  "areaHfb",
];
export const compareAndChooseRequiredFields: string[] = ["areaHfb"];
export const coordinationMediaRequiredFields: string[] = [
  "styleGroup",
  "areaHfb",
];
export const combineCoordinateRevitalizeRequiredFields: string[] = [
  "hfLtp",
  "styleGroup",
  "pricing",
  "areaHfb",
];

export const irresistibleOfferRequiredFields: string[] = [
  "hfLtp",
  "styleGroup",
  "areaHfb",
];

export const roomSettingsFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LIVING_SITUATION,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
  MediaFormFieldTypes.PRICING,
];

export const vignetteFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LIVING_SITUATION,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
  MediaFormFieldTypes.PRICING,
];

export const coordinationFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
];

export const homeFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LIVING_SITUATION,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
  MediaFormFieldTypes.PRICING,
];

export const vitalityFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
  MediaFormFieldTypes.PRICING,
];

export const crossOverFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
  MediaFormFieldTypes.PRICING,
];

export const showcaseFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
  MediaFormFieldTypes.PRICING,
];

export const perimeterBreakFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
];

export const statementMediaFormFields = [
  MediaFormFieldTypes.STYLE_GROUP,
  MediaFormFieldTypes.LONG_TERM_PRIORITY,
];

export enum MediaTypes {
  HOME = "HOME",
  ROOM = "ROOM",
  COMPACT = "COMPACT",
  COORDINATION_MEDIA = "COORDINATION_MEDIA",
  VIGNETTE = "VIGNETTE",
  ROOM_SETTINGS = "ROOM_SETTINGS",
  VITALITY = "VITALITY",
  CROSS_OVER = "CROSS_OVER",
  SHOW_CASE = "SHOW_CASE",
  PERIMETER_BREAK = "PERIMETER_BREAK",
  STATEMENT_MEDIA = "STATEMENT_MEDIA",
  ALL_PARTS_STUDIO = "ALL_PARTS_STUDIO",
  NONE = "NONE",
}

export enum RoomTypes {
  NONE = "NONE",
  KITCHEN = "KITCHEN",
  BEDROOM = "BEDROOM",
  LIVING_ROOM = "LIVING_ROOM",
  BATHROOM = "BATHROOM",
  HALLWAY = "HALLWAY",
  CHILDREN_ROOM = "CHILDREN_ROOM",
  OUTDOOR_BALCONY = "OUTDOOR_BALCONY",
  OTHER = "OTHER",
}
